export const TEST_RUNS_UPDATE_STATE = "TEST_RUNS_UPDATE_STATE"